<template>
  
      <!-- <div class="robot-loader">
        <h3 class="bounce-5">Please Wait. Processing.</h3>
        <img src="../../assets/images/robot-walk.gif" alt="">
      </div> -->

     <div class="loadingio-spinner-bars-5x93obslozi"><div class="ldio-fgxyg78h5kv">
<div></div><div></div><div></div><div></div>
</div></div>

</template>

<script>
  export default {
     
  }
</script>

<style lang="scss" scoped>
   .robot-loader{
      position: fixed;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: -20px;
      width: 325px;
      z-index: 1000;
     
      h3{
        background-color: rgb(248, 98, 87);
        text-align: center;
        padding: 5px;
        color: #fff;
        animation-duration: 2s;
        animation-iteration-count: infinite;
      }
   }
    
   .bounce-5 {
        animation-name: bounce-5;
        animation-timing-function: ease;
    }
    @keyframes bounce-5 {
        0%   { transform: scale(1,1)    translateY(0); }
        10%  { transform: scale(1.1,.9) translateY(0); }
        30%  { transform: scale(.9,1.1) translateY(-100px); }
        50%  { transform: scale(1,1)    translateY(0); }
        57%  { transform: scale(1,1)    translateY(-7px); }
        64%  { transform: scale(1,1)    translateY(0); }
        100% { transform: scale(1,1)    translateY(0); }
    }
   

@keyframes ldio-fgxyg78h5kv {
  0% { opacity: 1 }
  50% { opacity: .5 }
  100% { opacity: 1 }
}
.ldio-fgxyg78h5kv div {
  position: absolute;
  width: 20px;
  height: 80px;
  top: 60px;
  
  animation: ldio-fgxyg78h5kv 1s cubic-bezier(0.5,0,0.5,1) infinite;
}.ldio-fgxyg78h5kv div:nth-child(1) {
  transform: translate(30px,0);
  background: #e15b64;
  animation-delay: -0.6s;
}.ldio-fgxyg78h5kv div:nth-child(2) {
  transform: translate(70px,0);
  background: #f47e60;
  animation-delay: -0.4s;
}.ldio-fgxyg78h5kv div:nth-child(3) {
  transform: translate(110px,0);
  background: #f8b26a;
  animation-delay: -0.2s;
}.ldio-fgxyg78h5kv div:nth-child(4) {
  transform: translate(150px,0);
  background: #abbd81;
  animation-delay: -1s;
}
.loadingio-spinner-bars-5x93obslozi {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: #ffffff;
  position: fixed;
  left: 50%;
  top: 50%;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1), 0 2px 8px rgba(0,0,0,0.05);
  border-radius: 5px;
  transform: translate(-50%, -50%) scale(0.5);
}
.ldio-fgxyg78h5kv {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-fgxyg78h5kv div { box-sizing: content-box; }
/* generated by https://loading.io/ */
</style>